/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilityEligibleResultApiModel } from './capabilityEligibleResultApiModel';
import { ReportOccupationCapabilityApiModel } from './reportOccupationCapabilityApiModel';


export interface EmployeeStatusOverviewApiModel { 
    employeeId: number;
    employeeName: string;
    employeeSurname: string;
    occupations: Array<ReportOccupationCapabilityApiModel>;
    exclusiveCapabilities: Array<number>;
    capabilityEligibleResults: Array<CapabilityEligibleResultApiModel>;
}

